import React from "react";
import Login from "../_components/auth/Login";

function LoginPage() {
  return (
    <div className="">
      <Login />
      
    </div>
  );
}

export default LoginPage;
